"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatrixContextMenu = useMatrixContextMenu;
const react_1 = require("react");
const utils_1 = require("../../utils/utils");
function useMatrixContextMenu() {
    const [contextMenuState, setContextMenuState] = (0, react_1.useState)(null);
    const open = (0, react_1.useCallback)((params, dataMap, displayedProductTitles) => {
        var _a;
        // Parameter validation
        if (!params || !dataMap) {
            console.error('Invalid parameters passed to context menu');
            return;
        }
        const e = params.event;
        e.preventDefault();
        e.stopPropagation();
        params.api.clearFocusedCell();
        // Handle different column types:
        // - First column has field: 'value' - no specific product mapping
        // - Product columns have field: productTitle - has specific mapping
        const { field } = params.colDef;
        const { value: attributeValue } = params.data;
        if (!field || !attributeValue) {
            console.error('Missing field or attribute value in context menu');
            return;
        }
        let source;
        let rowLevelMapped = false;
        if (field !== 'value' && field !== 'totalProductCount') {
            // product column
            const key = (0, utils_1.getKey)(attributeValue, field);
            source = dataMap.get(key);
        }
        else {
            // This is the first column - check row-level mapping state
            // Only check columns that are actually displayed
            const displayedColumnTitles = (displayedProductTitles === null || displayedProductTitles === void 0 ? void 0 : displayedProductTitles.map((pt) => pt.title)) || [];
            // Check if ANY cell in this row is mapped (only for displayed columns)
            rowLevelMapped = displayedColumnTitles.some((columnTitle) => {
                const key = (0, utils_1.getKey)(attributeValue, columnTitle);
                const record = dataMap.get(key);
                return record === null || record === void 0 ? void 0 : record.isMapped;
            });
        }
        setContextMenuState({
            x: e.clientX,
            y: e.clientY,
            show: true,
            cellValue: params.value,
            isMapped: field === 'value' ? rowLevelMapped : ((_a = source === null || source === void 0 ? void 0 : source.isMapped) !== null && _a !== void 0 ? _a : false),
            title: params.colDef.field === 'value' ? '' : (params.colDef.field || ''),
            value: params.data.value,
            colId: params.colDef.colId,
            cellType: (0, utils_1.getCellType)(params),
        });
    }, []);
    const close = (0, react_1.useCallback)(() => setContextMenuState(null), []);
    return { contextMenu: contextMenuState, open, close };
}
